import colors from 'styles/colors';
import shadows from 'styles/shadows';

export const theme: ITheme = {
  colors,
  shadows,
};
